import promotionsConstants    from './promotions.constants';
import promotionsInitialState from './promotions.state';

function promotionsReducer(state = promotionsInitialState, action) {
  switch (action.type) {
    case promotionsConstants.GET_PROMOTIONS_LIST_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case promotionsConstants.GET_PROMOTIONS_LIST_SUCCESS:
      state = {
        ...state,
        items:              action.items || promotionsInitialState.items,
        headItems:          action.headItems || promotionsInitialState.headItems,
        count:              +action.count || promotionsInitialState.count,
        loading:            false,
        initialStateLoaded: true,
        mainPromotion:      action.items[0] || promotionsInitialState.items,
      };
      break;

    case promotionsConstants.GET_PROMOTIONS_LIST_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case promotionsConstants.GET_PROMOTIONS_DETAIL_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case promotionsConstants.GET_PROMOTIONS_DETAIL_SUCCESS:
      state = {
        ...state,
        article:      {
          buttonLink:        action.buttonLink || promotionsInitialState.article.buttonLink,
          buttonName:        action.buttonName || promotionsInitialState.article.buttonName,
          contactButtonName: action.contactButtonName || promotionsInitialState.article.contactButtonName,
          newsId:            +action.newsId || promotionsInitialState.article.newsId,
          label:             action.label || promotionsInitialState.article.label,
          headImage:         action.headImage || promotionsInitialState.article.headImage,
          content:           action.content || promotionsInitialState.article.content,
          createdAt:         action.createdAt || promotionsInitialState.article.createdAt,
          createdAtIso:      action.createdAtIso || promotionsInitialState.article.createdAtIso,
          updatedAtIso:      action.updatedAtIso || promotionsInitialState.article.updatedAtIso,
          readingTime:       action.readingTime || promotionsInitialState.article.readingTime,
          relatedNews:       action.relatedNews || promotionsInitialState.article.relatedNews,
          activeFrom:        action.activeFrom || promotionsInitialState.article.activeFrom,
          activeTo:          action.activeTo || promotionsInitialState.article.activeTo,
          meta:              {
            title: action.metaTitle || promotionsInitialState.article.meta.title,
            meta:  {
              keywords:    action.keywords || promotionsInitialState.article.meta.meta.keywords || '',
              description: action.description || promotionsInitialState.article.meta.meta.description || '',
              canonical:   action.canonical || promotionsInitialState.article.meta.meta.canonical || '',
            },
          },
        },
        loading:      false,
        detailLoaded: true,
      };
      break;

    case promotionsConstants.GET_PROMOTIONS_DETAIL_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case promotionsConstants.PROMOTIONS_SHOW_MORE_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case promotionsConstants.PROMOTIONS_SHOW_MORE_SUCCESS:
      state = {
        ...state,
        items:   [
          ...action.items,
        ],
        page:    action.page || state.page,
        loading: false,
      };
      break;

    case promotionsConstants.PROMOTIONS_SHOW_MORE_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case promotionsConstants.PROMOTIONS_DETAIL_RESET_INITIAL_STATE:
      state = {
        ...state,
        article:      promotionsInitialState.article,
        detailLoaded: promotionsInitialState.detailLoaded,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default promotionsReducer;